import { gql } from 'apollo-boost';

export const GET_AI_ORGANIZATION_BACKFILL_JOBS = gql`
    query GetAiOrganizationBackfillJobs($data: GetAiOrganizationBackfillJobsInput) {
        getAiOrganizationBackfillJobs(data: $data) {
            id
            userId
            requestedByAdminId
            status
            messageLimit
            autoMove
            forceReprocess
            processedCount
            autoMovedCount
            suggestedOnlyCount
            skippedNoCreditsCount
            creditsCharged
            estimatedCredits
            startedAt
            completedAt
            errorMessage
            lockedUntil
            attempts
            nextRetryAt
            pipelineVersion
            createdAt
            updatedAt
        }
    }
`;
